/*
 * @Author: cnblogs.com/vipzhou
 * @Date: 2018-02-22 21:30:19 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2018-02-22 22:02:47
 */

import * as http from './base'

/**
 * 获取region列表
 * @param {object} params 
 */
const getRegionList = params => {
  return http.fetch('/regions', params)
}

/**
 * 删除region
 * @param  {object} params
 */
const deleteRegionByld = id => {
  return http.del(`/regions/${id}`)
}
/**
 * 获取region详情
 * @param  {id} ida
 */
const getRegionDetail = id => {
  return http.fetch(`/regions/${id}`, {})
}

/**
 * 保存设备信息
 * @param {object} region 
 */
const updateRegionInfo = region => {
  if (!region.id) {
    return Promise.reject(new Error(`arg id can't be null`))
  }
  return http.put(`/regions/${region.id}`, region)
}

/**
 * 添加设备
 * @param {recharge对象} region 
 */
const addRegion = region => {
  return http.post('/regions', region)
}

const bulkDelete = params => {
  return http.post('/regions/bulkDelete', params)
}
export { getRegionList, deleteRegionByld, getRegionDetail, updateRegionInfo, addRegion, bulkDelete }


// WEBPACK FOOTER //
// ./src/http/region.js